import { collectDeviceFingerprint } from '../utils/deviceFingerprint';

function removeTrailingSlashes(url = '') {
  let normalizedUrl = url;

  while (normalizedUrl.endsWith('/')) {
    normalizedUrl = normalizedUrl.slice(0, -1);
  }

  return normalizedUrl;
}

// const baseUrl = removeTrailingSlashes('https://api.kitohealth.org');
// const baseUrl = removeTrailingSlashes('https://api.demo.kitohealth.org');
const baseUrl = removeTrailingSlashes('https://api.develop.kitohealth.org');
// onst baseUrl = removeTrailingSlashes('http://localhost:8000');

function getStoredMode() {
  if (typeof localStorage === 'undefined') {
    return '';
  }

  return localStorage.getItem('mode') || '';
}

function appendModeQuery(path) {
  const mode = getStoredMode();

  if (!mode) {
    return path;
  }

  const separator = path.includes('?') ? '&' : '?';

  return `${path}${separator}mode=${encodeURIComponent(mode)}`;
}

function buildApiUrl(path, { includeMode = false } = {}) {
  const resolvedPath = includeMode ? appendModeQuery(path) : path;

  return `${baseUrl}${resolvedPath}`;
}

export function getApiBaseUrl() {
  return baseUrl;
}

// ping
export async function pingAPI() {
  return fetch(buildApiUrl('/'));
}

export async function tts(text, voice) {
  return fetch(buildApiUrl('/tts', { includeMode: true }), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, voice }),
  });
}

// Feedback Component
export async function addRatingAPI(userId, journeyId, rating, message) {
  return fetch(buildApiUrl('/rating', { includeMode: true }), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      userId,
      journeyId,
      rating,
      message,
    }),
  });
}

// ClinicalFeedback Component
export async function AddClinicalFeedbackAPI(userId, journeyId, questionnaire) {
  return fetch(buildApiUrl('/clinicalFeedback', { includeMode: true }), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      userId,
      journeyId,
      questionnaire,
    }),
  });
}

// OtherSymptom Component
export async function addSuggestedSymptom(userId, suggestedSymptom, ageGroup, language) {
  return fetch(buildApiUrl('/suggestedSymptom', { includeMode: true }), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      userId,
      suggestedSymptom,
      ageGroup,
      language,
    }),
  });
}

// Questions Component
export async function GetAlgorithmAPI(ageGroup, symptom, language) {
  return fetch(buildApiUrl(`/algorithms/${ageGroup}${symptom}/${language}`));
}

// TO DO: Change localhost to development url (the base url above)
// Output Component
export async function GetRedOutputAPI(params, userId) {
  return fetch(buildApiUrl(`/algorithms/output/redAnswer/${params}/${userId}`, { includeMode: true }));
}

export async function GetOutputAPI(params, userId) {
  return fetch(buildApiUrl(`/algorithms/output/${params}/${userId}`, { includeMode: true }));
}

export function sendNotification(sub) {
  fetch(buildApiUrl('/send-notification'), {
    method: 'POST',
    body: JSON.stringify(sub),
    headers: {
      'content-type': 'application/json',
    },
  });
}

export function getSymptoms(language, ageGroup) {
  return fetch(buildApiUrl(`/symptoms/language/${language}/age/${ageGroup}`));
}

export function getUserMetric(sessionId) {
  return fetch(buildApiUrl(`/page-metric/${sessionId}`));
}

export function createUserMetric(metric) {
  return fetch(buildApiUrl('/page-metric', { includeMode: true }), {
    method: 'POST',
    body: JSON.stringify(metric),
    headers: {
      'content-type': 'application/json',
    },
  });
}

export function updateUserMetric(sessionId, metric) {
  return fetch(buildApiUrl(`/page-metric/${sessionId}`, { includeMode: true }), {
    method: 'PUT',
    body: JSON.stringify(metric),
    headers: {
      'content-type': 'application/json',
    },
  });
}

export function getPopups() {
  return fetch(buildApiUrl('/popups'));
}

export function saveLocation(location) {
  return fetch(buildApiUrl('/locations'), {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(location),
  });
}

export function getSpinWheelProgress(sessionId) {
  return fetch(buildApiUrl(`/spin-wheel-progress/${encodeURIComponent(sessionId)}`));
}

// Counts today's visit for the session (creating the record on the first one)
// and returns the progress the server holds. The clock offset lets the server
// decide what "today" means for this user.
// Counts today's visit. The device description travels along so the server
// can log which device the check-in came from.
export function openSpinWheelProgress(sessionId, timezoneOffsetMinutes) {
  return fetch(buildApiUrl(`/spin-wheel-progress/${encodeURIComponent(sessionId)}/open`, { includeMode: true }), {
    method: 'POST',
    body: JSON.stringify({ timezone_offset_minutes: timezoneOffsetMinutes, device: collectDeviceFingerprint() }),
    headers: {
      'content-type': 'application/json',
    },
  });
}

// Asks the server to play the session's spin. The server draws the prize and
// updates stock and the basket; the response says which slice to stop on.
export function playSpinWheel(sessionId, timezoneOffsetMinutes) {
  return fetch(buildApiUrl(`/spin-wheel-progress/${encodeURIComponent(sessionId)}/spin`), {
    method: 'POST',
    body: JSON.stringify({ timezone_offset_minutes: timezoneOffsetMinutes, device: collectDeviceFingerprint() }),
    headers: {
      'content-type': 'application/json',
    },
  });
}

// Returns the items that belong on the wheel right now: active, still in stock.
export function getSpinWheelItems() {
  return fetch(buildApiUrl('/spin-wheel-items'));
}
